import AjaxManager from "../ajaxManager";
import FavouriteModalManager from "./favouriteModalManager";

export default class UserWebFavouriteGroupManager {
    constructor() {
        this.ajaxManager = new AjaxManager();
        this.notificationShow = false;
        this.noUserFavoriteGroups = document.querySelector('#noUserFavourites');
        this.seeAllChollosButton = document.querySelector('#seeAllChollos');
        this.eventDelegation();
        new FavouriteModalManager();
    }

    eventDelegation() {
        this.setAddFavouriteGroupClickListener('[data-entity="group"] [data-action="add-favourite"]');
        this.setRemoveFavouriteGroupClickListener('[data-entity="group"] [data-action="remove-favourite"]');

        $('[data-entity="group"] [data-open="login-user"]').on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            myApp.customModalManager.openModal('#userModal');

        });

        let favoriteGroupsContainer = document.querySelector('#favourite-groups');

        if (favoriteGroupsContainer && favoriteGroupsContainer.childElementCount > 0) {
            this.noUserFavoriteGroups.style.display = 'none';
        } else if (this.noUserFavoriteGroups) {
            this.noUserFavoriteGroups.style.display = 'flex';
        }
    };

    setAddFavouriteGroupClickListener(selector, callback = null) {
        $(selector).on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.addFavouriteGroup($(e.currentTarget), callback);
        });
    }

    setRemoveFavouriteGroupClickListener(selector, callback = null) {
        $(selector).on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.removeFavouriteGroup($(e.currentTarget), callback);
        });
    }

    addFavouriteGroup(element, externalCallback = null) {
        const url = myApp.config.routing.userAddFavouriteGroup;
        const groupId = $(element).attr('data-group-id');
        let addFavourites = $('[data-entity="group"][data-id="' + groupId + '"] [data-add-favourite]' +
            ', #infowindow-' + groupId + ' [data-add-favourite]');
        myApp.domAnimator.showAnimatedHeart(addFavourites);

        const data = {
            groupId: groupId,
            userToken: $(element).data('user-token')
        };

        if (externalCallback) {
            externalCallback(groupId);
        }

        const callback = (response) => {
            const removeButton = $('[data-entity="group"][data-id="' + groupId + '"] [data-remove-favourite]' +
                ', #infowindow-' + groupId + ' [data-remove-favourite]');

            if (response.status === true) {
                myApp.domAnimator.animateHeart($(addFavourites), removeButton, response.status);
                const favouriteCounts = document.querySelectorAll('[data-entity="group"]' +
                    '[data-id="' + groupId + '"] [data-entity="favourite-count"], #infowindow-' + groupId +
                    ' [data-entity="favourite-count"]');
                if (favouriteCounts) {
                    favouriteCounts.forEach((element) => {
                        element.textContent = parseInt(element.textContent) + 1;
                        if (element.textContent == 1 && element.classList.contains('hidden') && !element.dataset.noCounter) {
                            element.classList.remove('hidden');
                        }
                    });
                }
            } else {
                myApp.domAnimator.animateHeart($(addFavourites), removeButton, response.status);
            }
            const customFavouriteNotification = document.querySelector('#favorite-added');

            if (!this.notificationShow && customFavouriteNotification) {
                customFavouriteNotification.openCustomNotification();
                if (myApp.deviceDetector.isXsScreen()) {
                    document.querySelector('.searcher-backdrop').addEventListener("click", this.onSiteInteract);
                    $('.searcher-backdrop').show().css('opacity', '0');
                }
                this.notificationShow = true;
            }
        };
        this.ajaxManager.ajaxCall('POST', url, data, callback.bind(this));
    };

    removeFavouriteGroup(element, externalCallback = null) {
        const url = myApp.config.routing.userRemoveFavouriteGroup;
        const groupId = $(element).attr('data-group-id');
        const userToken = $(element).data('user-token');

        const usarFavouriteContainer = document.getElementById('favourite-groups');
        const removeFavouriteModal = document.getElementById('removeFavouriteModal');
        if (usarFavouriteContainer && removeFavouriteModal && !removeFavouriteModal.classList.contains('custom-modal-open')) {
            removeFavouriteModal.setAttribute('group-id', groupId);
            myApp.customModalManager.openModal('#removeFavouriteModal');
        } else {
            const data = {
                groupId: groupId,
                userToken: userToken
            };

            if (externalCallback) {
                externalCallback(groupId);
            }

            const callback = function (response) {
                $('#remove_favourite_group_' + groupId).modal('hide');
                const notification = document.querySelector('#favorite-added');
                if (notification != null && !notification.customNotification.classList.contains('d-none')) {
                    notification.closeCustomNotification();
                }

                if (response.status === true) {
                    const groupsFav = document.querySelector('#favourite-groups');
                    if (groupsFav && groupsFav.childElementCount > 0) {
                        $('[data-entity="group"][data-id="' + groupId + '"]').remove();
                        let favouriteGroups = myApp.book.availabilityManager.availabilityList;
                        if (favouriteGroups && myApp.mapManager) {
                            myApp.book.availabilityManager.availabilityList = favouriteGroups.filter(elem => elem.id != groupId);
                            myApp.mapManager.hideMarkerFromDeletedFavouriteGroup(groupId);
                        }
                        if (groupsFav.childElementCount === 0) {
                            this.noUserFavoriteGroups.style.display = 'flex';
                            this.seeAllChollosButton.style.display = 'none';
                            let favouriteMapButton = document.querySelector('[name="preview-map"]');
                            if (favouriteMapButton) favouriteMapButton.style.display = 'none';
                            myApp.customModalManager.closeModal('#modal_group_map');
                        }
                    } else {
                        let addFavContainer = $('[data-entity="group"][data-id="' + groupId + '"] [data-add-favourite]' +
                            ', #infowindow-' + groupId + ' [data-add-favourite]');
                        addFavContainer.find('[data-entity="animatedHeart"]').removeClass('active');
                        addFavContainer.show();
                        $('[data-entity="group"][data-id="' + groupId + '"] [data-remove-favourite]' +
                            ', #infowindow-' + groupId + ' [data-remove-favourite]').hide();
                    }
                    const favouriteCounts = document.querySelectorAll('[data-entity="group"]' +
                        '[data-id="' + groupId + '"] [data-entity="favourite-count"], #infowindow-' + groupId +
                        ' [data-entity="favourite-count"]');
                    if (favouriteCounts) {
                        favouriteCounts.forEach((element) => {
                            element.textContent = parseInt(element.textContent) - 1;
                            if (element.textContent == 0 && !element.classList.contains('hidden') && !element.dataset.noCounter) {
                                element.classList.add('hidden');
                            }
                        });
                    }
                }
            };
            this.ajaxManager.ajaxCall('POST', url, data, callback.bind(this));
        }
    };

    onSiteInteract(event) {
        if (event.type === 'scroll' || !$(event.target).closest('#favorite-added').length) {
            event.preventDefault();
            event.stopPropagation();
            document.querySelector('#favorite-added').closeCustomNotification();
            $('.searcher-backdrop').hide().css('opacity', '1');
            document.querySelector('.searcher-backdrop').removeEventListener('click', this.onSiteInteract);
        }
    }
}
